import {useCallback} from "react";
import {UAC, User} from "./UserManager.types";
import {notification} from "antd";
import Language from "../../../language";
import {getUser} from "../../../redux/appEnvironment.selector";
import {useSelector} from "react-redux";

export const useHandleActiveChange = (updateAssocClientActive: ({uac, active}: {
  forBatch?: boolean
  uac: { id: number | string },
  active: boolean
}) => Promise<any>) => useCallback((uac: UAC, active: boolean, showNotification = true) => {
  updateAssocClientActive({
    forBatch: true,
    uac,
    active,
  }).then(() => {
    if (showNotification) {
      notification.success({
        message: Language.get(`admin.user.${active ? 'actions.activeUser' : 'actions.inactiveUser'}`),
        description: Language.get(`admin.user.${active ? 'actions.activeUserDescription' : 'actions.inactiveUserDescription'}`),
      })
    }
  })
}, [updateAssocClientActive])

export const useGetIsCurrentUser = () => {
  const currentUser = useSelector(getUser)
  return useCallback((user: User) => currentUser?.id === user.id, [currentUser?.id])
}